import { Injectable, inject } from '@angular/core';
import { APICommonService } from '@nationwide/internet-servicing-angular-services';

@Injectable({
    providedIn: 'root'
})
export class SetupTransactionService {
    private apiCommonService = inject(APICommonService);

    private TRANSACTION_ID = 'transactionId';

    getTransactionId(): string {
        if (sessionStorage.getItem(this.TRANSACTION_ID)) {
            return sessionStorage.getItem(this.TRANSACTION_ID);
        } else {
            this.setupTransactionId();
            return sessionStorage.getItem(this.TRANSACTION_ID);
        }
    }

    setupTransactionId(): void {
        sessionStorage.setItem(this.TRANSACTION_ID, this.apiCommonService.generateTransactionId());
    }
}